export default __webpack_public_path__ + "images/erickson-living.svg?63a239f78d37d9cec9583a5c4717640b";